import React, { useState } from 'react';
import { Box, List, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, Snackbar, Alert } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import TimelineIcon from '@mui/icons-material/Timeline';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LocalMoviesIcon from '@mui/icons-material/LocalMovies';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import LatestDialog from '../appDialog/latest';
import SeriesDialog from '../appDialog/series';
import SearchDialog from '../appDialog';
import MoviesDialog from '../appDialog/movies';
import TvDialog from '../appDialog/tv';
import AVDialog from '../appDialog/av';
import FavorDialog from '../appDialog/favor';
import BlogerDialog from '../appDialog/bloger';
import TelegramGroup from '../appDialog/telegramGroup';
import MsgSnackBar from '../common/msgSnack';
import TopVideoDialog from '../appDialog/topVideosDialog';
import FollowDialog from '../appDialog/followDialog';
import CameraIcon from '@mui/icons-material/Camera';
import { useUser } from '../../contexts/userContext';
import LoginRegisterDialog from '../appDialog/login';
import PersonOutlineSharpIcon from "@mui/icons-material/PersonOutlineSharp";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import BookmarkIcon from "@mui/icons-material/Bookmark";


export default function StyledDrawerDialog({ open, setOpen, matches }) {
  const [openSearch, setOpenSearch] = useState(false);
  const [chipTitle, setChipTitle] = useState(null);
  const [openSeries, setOpenSeries] = useState(false);
  const [openLatest, setOpenLatest] = useState(false);
  const [openFollow, setOpenFollow] = useState(false);
  const [openFavor, setOpenFavor] = useState(false);
  const [openAV, setOpenAV] = useState(false);
  const [openMovies, setOpenMovies] = useState(false);
  const [openTv, setOpenTv] = useState(false);
  const [openBloger, setOpenBloger] = useState(false);
  const [msgSnackOpen, setMsgSnackOpen] = useState(false);
  const [openTelegram, setOpenTelegram] = useState(false);
  const [openTop, setOpenTop] = useState(false);
  const { userData } = useUser();
  const [category, setCategory] = useState("周排行榜");
  const [openLogin, setOpenLogin] = useState(false);

  // 登录提示 Snackbar
  const [loginSnackOpen, setLoginSnackOpen] = useState(false);
  const handleLoginSnackClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setLoginSnackOpen(false);
  };

  const toggleOpen = (val) => () => setOpen(val);

  const menuItemSx = {
    borderRadius: 2,
    mx: 1,
    my: 0.25,
    px: 2,
    py: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    opacity: 0.85,
    '& .MuiListItemIcon-root': {
      minWidth: 36,
      display: 'flex',
      justifyContent: 'center',
      color: '#000',
    },
    '& .MuiListItemText-root': {
      color: '#000',
    },
    '&:hover': {
      background: 'linear-gradient(90deg, #D35FFF33, #FF6FCF33, #7D5FFF33)',
    },
  };

  const itemVariants = {
    hidden: { x: 50, opacity: 0 },
    visible: (i) => ({
      x: 0,
      opacity: 1,
      transition: { delay: i * 0.08, type: 'spring', stiffness: 300, damping: 25 },
    }),
  };

  const menuItemsTop = [
    {
      icon: <CameraIcon />,
      text: '关注圈',
      action: () => {
        if (!userData) {
          setLoginSnackOpen(true); // 👈 提示用户登录
          return;
        }
        setChipTitle('我关注的');
        setOpenFollow(true);
      },
    },
    {
      icon: <FiberNewIcon />,
      text: '全部更新',
      action: () => {
        setChipTitle('最新发布');
        setOpenLatest(true);
      },
    },
    {
      icon: <TimelineIcon />,
      text: '热播排行榜',
      action: () => {
        setCategory('热播');
        setOpenTop(true);
      },
    },
    {
      icon: <BookmarkIcon />,
      text: '我的收藏',
      action: () => {
        setChipTitle("我的收藏");
        setOpenFavor(true);
      },
    },
  ];

  const menuItemsBottom = [
    { icon: <LocalFireDepartmentIcon />, text: '电报频道及工具', action: () => { setChipTitle('夫妻活动群'); setOpenTelegram(true); } },
    { icon: <YouTubeIcon />, text: '免费AV', action: () => { setChipTitle('免费AV'); setOpenAV(true); } },
    { icon: <LocalMoviesIcon />, text: '免费电影', action: () => { setChipTitle('免费电影'); setOpenMovies(true); } },
    { icon: <LiveTvIcon />, text: '免费电视剧', action: () => { setChipTitle('免费电视剧'); setOpenTv(true); } },
  ];

  const personItemsBottom = [
    { icon: <PersonOutlineSharpIcon />, text: '我的账号', action: () => { setOpenLogin(true); } },
    { icon: <SupportAgentIcon />, text: '联系客服', action: () => window.chaport?.q('open') },
  ];


  return (
    <>
      
      <LoginRegisterDialog open={openLogin} onClose={() => setOpenLogin(false)} />
      {/* 登录提示 Snackbar */}
      <Snackbar
        open={loginSnackOpen}
        autoHideDuration={3000}
        onClose={handleLoginSnackClose}
        anchorOrigin={{ vertical: 'center', horizontal: 'center' }} // 居中
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: 'rgba(0,0,0,0.6)', // 半透明黑色
            color: '#fff',                     // 白色文字
            borderRadius: 2,                   // 圆角
            padding: '12px 24px',              // 内边距
            minWidth: '200px',
            textAlign: 'center',
          },
        }}
      >
        <Alert onClose={handleLoginSnackClose} severity="warning" sx={{ width: '100%' }}>
          请先登录才能使用此功能
        </Alert>
      </Snackbar>


      {/* 弹窗区域 */}
      <FollowDialog openSeries={openFollow} setOpenSeries={setOpenFollow} matches={matches} chipTitle={chipTitle} />
      <MsgSnackBar vertical="bottom" msg="已经为您滚动到最新发布了" msgSnackOpen={msgSnackOpen} setMsgSnackOpen={setMsgSnackOpen} />
      <LatestDialog openSeries={openLatest} setOpenSeries={setOpenLatest} matches={matches} chipTitle={chipTitle} />
      <SearchDialog openSearch={openSearch} setOpenSearch={setOpenSearch} matches={matches} chipTitle={chipTitle} />
      <SeriesDialog openSeries={openSeries} setOpenSeries={setOpenSeries} matches={matches} chipTitle={chipTitle} />
      <MoviesDialog openMovies={openMovies} setOpenMovies={setOpenMovies} matches={matches} chipTitle={chipTitle} />
      <TvDialog openMovies={openTv} setOpenMovies={setOpenTv} matches={matches} chipTitle={chipTitle} />
      <AVDialog openMovies={openAV} setOpenMovies={setOpenAV} matches={matches} chipTitle={chipTitle} />
      <FavorDialog openSearch={openFavor} setOpenSearch={setOpenFavor} matches={matches} chipTitle={chipTitle} />
      <BlogerDialog openBloger={openBloger} setOpenBloger={setOpenBloger} matches={matches} />
      <TelegramGroup open={openTelegram} onClose={() => setOpenTelegram(false)} />
      <TopVideoDialog openMovies={openTop} setOpenMovies={setOpenTop} chipTitle={"热播榜"} matches={matches} />

      {/* 左侧抽屉 */}
      <AnimatePresence>
        {open && (
          <>
            <motion.div
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              exit={{ x: '-100%' }}
              transition={{ type: 'tween', duration: 0.25 }}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: 260,
                height: '100vh',
                background: 'rgba(255,255,255,0.5)',
                backdropFilter: 'blur(15px)',
                WebkitBackdropFilter: 'blur(15px)',
                boxShadow: '2px 0 20px rgba(0,0,0,0.2)',
                zIndex: 1300,
                overflowY: 'auto',
                borderRadius: '0 0 0 16px',
              }}
            >
              {/* Logo */}
              <Box sx={{ position: 'sticky', top: 0, zIndex: 1350, py: 1, px: 1 }}>
                <List sx={{ px: 1, mb: 0.25 }}>
                  <ListItem disablePadding sx={{ px: 2 }}>
                    <ListItemText
                      primaryTypographyProps={{ component: 'div' }}
                      secondaryTypographyProps={{ component: 'div' }}
                      primary={
                        <Box
                          sx={{
                            fontSize: 20,
                            fontWeight: 600,
                            fontFamily: "'XiaowuWenKai', serif",
                            background: "linear-gradient(45deg, #D35FFF, #FF6FCF, #7D5FFF)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            display: "inline-block",
                          }}
                        >
                          夜未央
                        </Box>
                      }
                      secondary={
                        <Box
                          sx={{
                            fontSize: 14,
                            background: "linear-gradient(45deg, #D35FFF, #FF6FCF, #7D5FFF)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            display: "inline-block",
                            opacity: 0.8,
                          }}
                        >
                          52ywy.com
                        </Box>
                      }
                    />
                  </ListItem>
                </List>
              </Box>

              {/* 菜单 */}
              <List sx={{ px: 1 }}>
                {menuItemsTop.map((item, idx) => (
                  <motion.div key={idx} custom={idx} initial="hidden" animate="visible" variants={itemVariants}>
                    <ListItem disablePadding>
                      <ListItemButton onClick={item.action} sx={menuItemSx}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText primary={item.text} />
                      </ListItemButton>
                    </ListItem>
                  </motion.div>
                ))}
              </List>

              <Divider sx={{ borderColor: '#aaa', my: 0.5, mx: 1 }} />

              {/* 底部菜单 */}
              <List sx={{ px: 1 }}>
                <ListItem disablePadding sx={{ pl: 2, pb: 0.5 }}>
                  <ListItemText
                    primary="电报专属区"
                    primaryTypographyProps={{ fontSize: 14, fontWeight: 700, color: '#000' }}
                  />
                </ListItem>

                {menuItemsBottom.map((item, idx) => (
                  <motion.div key={idx} custom={idx + menuItemsTop.length} initial="hidden" animate="visible" variants={itemVariants}>
                    <ListItem disablePadding>
                      <ListItemButton onClick={item.action} sx={menuItemSx}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText primary={item.text} />
                      </ListItemButton>
                    </ListItem>
                  </motion.div>
                ))}
              </List>

              {/* 账户区 */}
<List sx={{ px: 1, mt: 1 }}>
  <ListItem disablePadding sx={{ pl: 2, pb: 0.5 }}>
    <ListItemText
      primary="账户区"
      primaryTypographyProps={{ fontSize: 14, fontWeight: 700, color: '#000' }}
    />
  </ListItem>

  {personItemsBottom.map((item, idx) => (
    <motion.div
      key={idx}
      custom={idx + menuItemsTop.length + menuItemsBottom.length}
      initial="hidden"
      animate="visible"
      variants={itemVariants}
    >
      <ListItem disablePadding>
        <ListItemButton onClick={item.action} sx={menuItemSx}>
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItemButton>
      </ListItem>
    </motion.div>
  ))}
</List>


              
            </motion.div>

            {/* 遮罩 */}
            <motion.div
              onClick={toggleOpen(false)}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{
                position: 'fixed',
                top: 0,
                left: 260,
                width: 'calc(100vw - 260px)',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.3)',
                zIndex: 1290,
              }}
            />
          </>
        )}
      </AnimatePresence>
    </>
  );
}
